import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TerminalAdminModule } from './terminal-admin/terminal-admin.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TerminalAdminModule
  ]
})
export class TerminalModule { }
